import { useCallback } from "react";
import { useCurrentAccountId } from "@zapier/identity";
import emitUserInteractionEvent, {
  UserInteractionName,
} from "./emitUserInteractionEvent";

interface ChatbotChangeOwnerModalEvent {
  optionSelected: ChatbotChangeOwnerModalAction;
  chatbotId?: string;
  eventAction?: "click" | "view";
}

export type ChatbotChangeOwnerModalAction =
  | "confirm"
  | "cancel"
  | "success"
  | "error";

export function useEmitChatbotChangeOwnerModalEvent() {
  const accountId = useCurrentAccountId();

  const emit = useCallback(
    ({
      optionSelected,
      chatbotId,
      eventAction,
    }: ChatbotChangeOwnerModalEvent) => {
      emitUserInteractionEvent({
        accountId,
        interactionName: UserInteractionName.ChatbotChangeOwnerModal,
        optionSelected,
        eventAction: eventAction ?? "click",
        customTrackingFields: {
          chatbot_id: chatbotId,
        },
      });
    },
    [accountId],
  );

  return { emit };
}
